"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "bemClassName", {
  enumerable: true,
  get: function get() {
    return _bem.bemClassName;
  }
});
Object.defineProperty(exports, "Tabbordion", {
  enumerable: true,
  get: function get() {
    return _Tabbordion.default;
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _TabPanel.default;
  }
});
Object.defineProperty(exports, "TabLabel", {
  enumerable: true,
  get: function get() {
    return _TabLabel.default;
  }
});
Object.defineProperty(exports, "TabContent", {
  enumerable: true,
  get: function get() {
    return _TabContent.default;
  }
});

var _bem = require("./lib/bem");

var _Tabbordion = _interopRequireDefault(require("./components/Tabbordion"));

var _TabPanel = _interopRequireDefault(require("./components/TabPanel"));

var _TabLabel = _interopRequireDefault(require("./components/TabLabel"));

var _TabContent = _interopRequireDefault(require("./components/TabContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }